<template>
  <section>
    <!--工具条-->
    <CreateSchedulingToolbar :buttonList="buttonList" @callFunction="callFunction" ref="child">
    </CreateSchedulingToolbar>

    <!--列表-->
    <el-table :data="schedulingList" highlight-current-row v-loading="listLoading" @current-change="selectCurrentRow"
      @selection-change="handleSelectionChange" style="width: 100%;">
      <el-table-column type="selection" width="55">
      </el-table-column>
      <el-table-column fixed="left" type="index" label="序号" width="60"></el-table-column>
      <el-table-column fixed="left" label="操作" width="80">
        <template slot-scope="scope">
          <span v-for="item in operationButtonList" :key="item.id">
            <el-button type="text" style="padding-right:6px;" size="small" v-if="!item.IsHide"
              @click="operationButtonFunction(item, scope.row)">{{ item.name }}</el-button>
          </span>
        </template>
      </el-table-column>
      <el-table-column fixed="left" prop="DriverName" label="驾驶员" width="100" sortable></el-table-column>
      <el-table-column fixed="left" prop="SelfMadeNumber" label="车辆自编号" width="115" sortable></el-table-column>
      <el-table-column fixed="left" prop="LicensePlateNumber" label="车牌号" width="100" sortable></el-table-column>
      <el-table-column fixed="left" prop="LineName" label="线路" width="80" sortable></el-table-column>
      <el-table-column fixed="left" prop="SchedulingTemplateName" label="排班模版" width="120" sortable></el-table-column>
      <el-table-column v-for="(item, index) in dynamicTableHead" :key="index" :label="item.label"
        :property="item.property" :index="item.index" width="110" sortable
        :sort-method="(a, b) => sortByPositionSerial(a, b, item.index)">
        <template slot-scope="scope">
          <div v-if="scope.row[scope.column.property][scope.column.index].ShiftName === '休息'"
            style="color:#90EE90;font-weight:bold;"
            @click="handleShiftNameEdit(scope.row[scope.column.property][scope.column.index].AfterUpdateDriverName, scope.row[scope.column.property][scope.column.index])">
            休息
          </div>
          <div v-else-if="scope.row[scope.column.property][scope.column.index].IsCancelShift"
            @click="handleShiftNameEdit(scope.row[scope.column.property][scope.column.index].AfterUpdateDriverName, scope.row[scope.column.property][scope.column.index])">
            已取消
          </div>
          <div v-else-if="!scope.row[scope.column.property][scope.column.index].IsScheduling"
            @click="handleShiftNameEdit(scope.row[scope.column.property][scope.column.index].AfterUpdateDriverName, scope.row[scope.column.property][scope.column.index])">
            待排班
          </div>
          <div v-else
            @click="handleShiftNameEdit(scope.row[scope.column.property][scope.column.index].AfterUpdateDriverName, scope.row[scope.column.property][scope.column.index])">
            <div
              v-if="scope.row.DriverName !== scope.row[scope.column.property][scope.column.index].AfterUpdateDriverName">
              {{ scope.row[scope.column.property][scope.column.index].AfterUpdateDriverName }}</div>
            <div
              v-if="scope.row.LicensePlateNumber !== scope.row[scope.column.property][scope.column.index].AfterUpdateLicensePlateNumber">
              {{ scope.row[scope.column.property][scope.column.index].AfterUpdateLicensePlateNumber }}</div>
            {{ scope.row[scope.column.property][scope.column.index].ShiftName }}
          </div>
        </template>
      </el-table-column>
    </el-table>

    <!--工具条-->
    <el-col :span="24" class="toolbar">
      <el-pagination layout="total, sizes, prev, pager, next" @size-change="handleSizeChange"
        @current-change="handleCurrentChange" :current-page.sync="page" :page-sizes="[10, 15, 20, 50, 100, 200]"
        :total="total" style="float:right;"></el-pagination>
    </el-col>

    <!--排班界面-->
    <el-dialog title="排班" :visible.sync="schedulingFormVisible" v-model="schedulingFormVisible"
      :close-on-click-modal="false">
      <el-form :model="schedulingForm" label-width="80px" :rules="schedulingFormRules" ref="schedulingForm">
        <el-row>
          <el-col :span="10">
            <el-form-item label="线路名称" prop="BusLinesId" label-width="110px">
              <el-select style="width: 100%;" v-model="schedulingForm.BusLinesId" @change="selectBusLinesIdChanged"
                placeholder="请选择线路名称">
                <el-option v-for="item in busLiness" :key="item.Id" :value="item.Id" :label="item.LineChineseName">
                  <span style="float: left">{{ item.LineChineseName }}</span>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="10">
            <el-form-item label="发车模版" prop="SchedulingTemplateId" label-width="110px">
              <el-select style="width: 100%;" v-model="schedulingForm.SchedulingTemplateId"
                @change="selectSchedulingTemplateIdChanged" clearable placeholder="请选择发车模版">
                <el-option v-for="item in schedulingTemplateList" :key="item.Id" :value="item.Id"
                  :label="item.DepartureTemplate">
                  <span style="float: left">{{ item.DepartureTemplate }}</span>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col> -->
        </el-row>
        <el-row>
          <el-form-item label="本次排班时间" prop="SchedulingDateRange" label-width="110px">
            <el-date-picker v-model="schedulingForm.SchedulingDateRange" type="daterange" value-format="yyyy-MM-dd"
              format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
            </el-date-picker>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="排班依据" prop="SchedulingType" label-width="110px">
            <el-radio-group v-model="schedulingForm.SchedulingType" @change="schedulingTypeChange">
              <el-radio class="radio" label="模板班次">模板班次</el-radio>
              <el-radio class="radio" label="自动延续">自动延续</el-radio>
            </el-radio-group>
            <div style="color:#FF0000">注：“模板班次” 即以 “模板班次设定” 列表内容为基准，展开排班；</div>
            <div style="color:#FF0000">“自动延续” 则以系统内历史最后的班次为基准，展开排班；</div>
          </el-form-item>
        </el-row>

        <el-row>
          <el-table :data="schedulingForm.SchedulingTemplateList" stripe style="width: 100%">
            <el-table-column prop="SchedulingTemplateId" label="发车模板" width="200">
              <template slot-scope="scope">
                <el-select style="width: 100%;" v-model="scope.row.SchedulingTemplateId"
                  @change="selectSchedulingTemplateIdChanged" clearable placeholder="请选择发车模版">
                  <el-option v-for="item in schedulingTemplateList" :key="item.Id" :value="item.Id"
                    :label="item.DepartureTemplate">
                    <span style="float: left">{{ item.DepartureTemplate }}</span>
                  </el-option>
                </el-select>
                <!-- <el-input></el-input> -->
              </template>
            </el-table-column>
            <el-table-column prop="week" label="运行周" width="360">
              <template slot-scope="scope">
                <el-checkbox value="1" name="checkbox1" :disabled="scope.row.mondaydisabled"
                  :checked="scope.row.mondaychecked" @change="checkboxchange(scope.row.Id, 'monday')"
                  v-model="scope.row.monday" class="remember">周一</el-checkbox>
                <el-checkbox value="2" name="checkbox1" :disabled="scope.row.tuesdaydisabled"
                  :checked="scope.row.tuesdaychecked" @change="checkboxchange(scope.row.Id, 'tuesday')"
                  v-model="scope.row.tuesday" class="remember">周二</el-checkbox>
                <el-checkbox value="3" name="checkbox1" :disabled="scope.row.wednesdaydisabled"
                  :checked="scope.row.wednesdaychecked" @change="checkboxchange(scope.row.Id, 'wednesday')"
                  v-model="scope.row.wednesday" class="remember">周三</el-checkbox>
                <el-checkbox value="4" name="checkbox1" :disabled="scope.row.thursdaydisabled"
                  :checked="scope.row.thursdaychecked" @change="checkboxchange(scope.row.Id, 'thursday')"
                  v-model="scope.row.thursday" class="remember">周四</el-checkbox>
                <el-checkbox value="5" name="checkbox1" :disabled="scope.row.fridaydisabled"
                  :checked="scope.row.fridaychecked" @change="checkboxchange(scope.row.Id, 'friday')"
                  v-model="scope.row.friday" class="remember">周五</el-checkbox>
                <el-checkbox value="6" name="checkbox1" :disabled="scope.row.saturdaydisabled"
                  :checked="scope.row.saturdaychecked" @change="checkboxchange(scope.row.Id, 'saturday')"
                  v-model="scope.row.saturday" class="remember">周六</el-checkbox>
                <el-checkbox value="7" name="checkbox1" :disabled="scope.row.sundaydisabled"
                  :checked="scope.row.sundaychecked" @change="checkboxchange(scope.row.Id, 'sunday')"
                  v-model="scope.row.sunday" class="remember">周日</el-checkbox>

                <!-- <el-input v-model="scope.row.endtime"></el-input> -->
              </template>
            </el-table-column>
            <!-- <el-table-column
                prop="time"
                label="运行时间区间"
                width="380" hidden>
                <template slot-scope="scope">
                  <el-date-picker v-model="scope.row.SchedulingDateRange" type="daterange" value-format="yyyy-MM-dd"
                  format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
                </el-date-picker>
                </template>
              </el-table-column> -->
            <el-table-column prop="operate" label="操作">
              <template slot-scope="scope">
                <!-- <el-button 
                    size="mini" 
                    type="success" 
                    icon="el-icon-save" 
                    @click="handlesaveExperience(scope.$index, scope.row)">保存
                  </el-button>                -->
                <el-button size="mini" type="danger" icon="el-icon-delete"
                  @click="handleDeleteExperience(scope.$index, scope.row)">删除
                </el-button>

              </template>
            </el-table-column>
          </el-table>
          <div style="padding-bottom: 10px;">
            <el-button type="primary" icon="el-icon-plus" size="mini" @click="handleAddExperienceline">新增排班方案
            </el-button>
          </div>
        </el-row>
        <el-row>
          <el-form-item label="班次轮换" label-width="110px">
            <el-col :span="1">
              上
            </el-col>
            <el-col :span="7">
              <el-form-item prop="ShiftRotationDays">
                <el-input v-model="schedulingForm.ShiftRotationDays" style="width:170px;"
                  :disabled="schedulingForm.SchedulingType === '自动延续'" />
              </el-form-item>
            </el-col>
            <el-col :span="2">
              天移动
            </el-col>
            <el-col :span="7">
              <el-form-item prop="ShiftRotationPositions">
                <el-input v-model="schedulingForm.ShiftRotationPositions" style="width:170px;"
                  :disabled="schedulingForm.SchedulingType === '自动延续'" />
              </el-form-item>
            </el-col>
            <el-col :span="2">
              个位置
            </el-col>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="休息规则" label-width="110px">
            <el-col :span="1">
              上
            </el-col>
            <el-col :span="7">
              <el-form-item prop="RestRulesDays">
                <el-input v-model="schedulingForm.RestRulesDays" style="width:170px;"
                  :disabled="schedulingForm.SchedulingType === '自动延续'" />
              </el-form-item>
            </el-col>
            <el-col :span="2">
              天连休
            </el-col>
            <el-col :span="7">
              <el-form-item prop="RestRulesContinuityRestDays">
                <el-input v-model="schedulingForm.RestRulesContinuityRestDays" style="width:170px;"
                  :disabled="schedulingForm.SchedulingType === '自动延续'" />
              </el-form-item>
            </el-col>
            <el-col :span="1">
              天
            </el-col>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="休息后跳班" prop="IsSkipClasses" label-width="110px">
            <el-radio-group v-model="schedulingForm.IsSkipClasses" :disabled="schedulingForm.SchedulingType === '自动延续'">
              <el-radio class="radio" label="true">是</el-radio>
              <el-radio class="radio" label="false">否</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label-width="110px">
            <el-button @click.native="schedulingFormVisible = false">取消</el-button>
            <el-button type="primary" @click="handlePreview()">预览</el-button>
            <el-button type="primary" @click.native="schedulingSubmit" :loading="schedulingLoading">生成排班</el-button>
          </el-form-item>
        </el-row>
      </el-form>
    </el-dialog>

    <!--预览-->
    <el-dialog title="预览" :visible.sync="previewVisible" v-model="previewVisible" :close-on-click-modal="false"
      width="60%">
      <div v-for="itemlist in List" :key="itemlist.Id">
        <el-table :data="itemlist.previewSchedulingList" highlight-current-row style="width: 100%;">
          <el-table-column fixed="left" type="index" label="序号" width="60"></el-table-column>
          <el-table-column fixed="left" prop="LineName" label="线路" width="80"></el-table-column>
          <el-table-column fixed="left" prop="DriverName" label="驾驶员" width="100"></el-table-column>
          <el-table-column fixed="left" prop="LicensePlateNumber" label="车牌号" width="100"></el-table-column>
          <el-table-column fixed="left" prop="SchedulingTemplateName" label="排班模版" width="120" sortable></el-table-column>
          <el-table-column v-for="(item, index) in itemlist.previewDynamicTableHead" :key="index" :label="item.label"
            :property="item.property" :index="item.index" width="110" sortable
            :sort-method="(a, b) => sortByPositionSerial(a, b, item.index)">
            <template slot-scope="scope">
              <div v-if="scope.row[scope.column.property][scope.column.index].ShiftName === '休息'"
                style="color:#90EE90;font-weight:bold;">
                {{ scope.row[scope.column.property][scope.column.index].PreviewShiftName }}
              </div>
              <div v-else>
                <div
                  v-if="scope.row.DriverName !== scope.row[scope.column.property][scope.column.index].PreviewDriverName">
                  {{ scope.row[scope.column.property][scope.column.index].PreviewDriverName }}</div>
                <div
                  v-if="scope.row.LicensePlateNumber !== scope.row[scope.column.property][scope.column.index].PreviewVehicleName">
                  {{ scope.row[scope.column.property][scope.column.index].PreviewVehicleName }}</div>

                {{ scope.row[scope.column.property][scope.column.index].PreviewShiftName }}
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click.native="previewVisible = false">关闭预览</el-button>
      </div>
    </el-dialog>

    <!--编辑-->
    <el-dialog title="编辑" :visible.sync="editFormVisible" v-model="editFormVisible" :close-on-click-modal="false"
      width="25%">
      <el-form :model="editForm" label-width="80px" :rules="editFormRules" ref="editForm">
        <el-row>
          <el-form-item label="司机" prop="DriverId" label-width="110px">
            <el-select style="width: 100%;" v-model="editForm.DriverId" filterable placeholder="请选择司机">
              <el-option v-for="item in driverSelectList" :key="item.id" :value="item.id" :label="item.name"
                :disabled="item.disabled">
                <span style="float: left">{{ item.name }}</span>
              </el-option>
            </el-select>
          </el-form-item>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="editFormVisible = false">取消</el-button>
        <el-button type="primary" @click.native="editSubmit" :loading="editLoading">提交</el-button>
      </div>
    </el-dialog>

    <!--修改班次-->
    <el-dialog title="修改班次" :visible.sync="editShiftNameFormVisible" v-model="editShiftNameFormVisible"
      :close-on-click-modal="false" width="25%">
      <el-form :model="editShiftNameForm" label-width="80px" ref="editShiftNameForm">
        <el-row>
          <!-- <el-form-item label="司机" prop="AfterUpdateDriverName" label-width="110px">
            <el-input v-model="editShiftNameForm.AfterUpdateDriverName" :disabled="true" />
          </el-form-item> -->
          <el-form-item label="司机" prop="AfterUpdateDriverName" label-width="110px">
            <el-select style="width: 100%;" v-model="editShiftNameForm.AfterUpdateDriverId" @change="Drivechange"
              filterable placeholder="请选择司机">
              <el-option v-for="item in driverList" :key="item.Id" :value="item.Id" :label="item.Name">
                <span style="float: left">{{ item.Name }}</span>
              </el-option>
            </el-select>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="车牌号" prop="VehicleId" label-width="110px">
            <el-select style="width: 100%;" v-model="editShiftNameForm.AfterUpdateVehicleId" filterable
              placeholder="请选择车牌号">
              <el-option v-for="item in vehicleList" :key="item.Id" :value="item.Id" :label="item.LicensePlateNumber">
                <span style="float: left">{{ item.LicensePlateNumber }}</span>
              </el-option>
            </el-select>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="发车日期" prop="DepartureDateStr" label-width="110px">
            <el-input v-model="editShiftNameForm.DepartureDateStr" :disabled="true" />
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="取消班次" prop="IsCancelShift" label-width="110px">
            <el-switch v-model="editShiftNameForm.IsCancelShift"></el-switch>
          </el-form-item>
        </el-row>
        <el-row v-if="!editShiftNameForm.IsCancelShift">
          <el-form-item label="发车线路" prop="AfterUpdateBusLinesId" label-width="110px">
            <el-select style="width: 100%;" v-model="editShiftNameForm.AfterUpdateBusLinesId" placeholder="请选择发车线路">
              <el-option v-for="item in busLiness" :key="item.Id" :value="item.Id" :label="item.LineChineseName">
                <span style="float: left">{{ item.LineChineseName }}</span>
              </el-option>
            </el-select>
          </el-form-item>
        </el-row>
        <el-row v-if="!editShiftNameForm.IsCancelShift">
          <el-form-item label="班次名称" prop="ShiftName" label-width="110px">
            <el-select style="width: 100%;" v-model="editShiftNameForm.ShiftName" filterable placeholder="请选择班次名称">
              <el-option v-for="item in shiftNameList" :key="item" :value="item" :label="item">
                <span style="float: left">{{ item }}</span>
              </el-option>
            </el-select>
          </el-form-item>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click.native="lookUpOperateDataLog">查看操作日记</el-button>
        <el-button @click.native="editShiftNameFormVisible = false">取消</el-button>
        <el-button type="primary" @click.native="editShiftNameSubmit" :loading="editShiftNameLoading">提交</el-button>
      </div>
    </el-dialog>

    <!--操作日记-->
    <el-dialog title="操作日记" :visible.sync="operateDataLogFormVisible" v-model="operateDataLogFormVisible"
      :close-on-click-modal="false" :destroy-on-close="true" width="60%">
      <OperateDataLog v-if="operateDataLogFormVisible" :entityName="entityName" :entityKey="entityKey"></OperateDataLog>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="operateDataLogFormVisible = false">关闭</el-button>
      </div>
    </el-dialog>
  </section>
</template>

<script>
import util from "../../../util/date";
import { getSchedulingListPage, getSchedulingRuleData, addScheduling, editScheduling, getBusLinesListPage, getDriverListPage, getVehiclesListPage, getClassSubitem, editSchedulingBusLinesIdAndShiftName, getBusLinesIdDriverIdList, clearScheduling, exportScheduling, getByDriverIdVehiclesData, previewScheduling, getSchedulingTemplateListPage, deleteScheduling, getShiftNameListPage } from "../../api/api";
import { getButtonList, getOperationButtonList } from "../../promissionRouter";
import CreateSchedulingToolbar from "../../components/QueryToolbar/CreateSchedulingToolbar";
import OperateDataLog from "../../components/OperateDataLog";

export default {
  components: { CreateSchedulingToolbar, OperateDataLog },
  data() {
    return {
      options: [],
      value: '',
      value1: '',
      month1: '',
      month2: '',
      filters: {
        busLinesId: "",
        departureDate: "",
        schedulingTemplateId: "",
      },
      entityName: 'Scheduling', //操作日记中的表名称
      entityKey: '',  //操作日记中的表的Id
      buttonList: [],
      operationButtonList: [],
      dynamicTableHead: [],
      schedulingList: [], //排班列表
      List: [{
        previewSchedulingList: [], //预览排班列表
        previewDynamicTableHead: []//预览排班列表动态表头
      }], //排班列表
      previewSchedulingList: [], //预览排班列表
      previewDynamicTableHead: [],//预览排班列表动态表头
      busLiness: [], //线路列表
      busLinesIdDriverList: [], //当前线路所有驾驶员列表
      driverList: [], //驾驶员原始列表
      vehicleList: [], //车辆列表
      driverSelectList: [], //驾驶员下拉列表
      shiftNameList: [], //班次名称列表
      schedulingTemplateList: [], //排班模版列表
      total: 0,
      page: 1,
      pageSize: 10,
      listLoading: false,
      sels: [], //列表选中列
      currentRow: null,
      previewVisible: false, //预览界面是否显示
      operateDataLogFormVisible: false, //查看操作日记界面是否显示
      schedulingFormVisible: false, //排班界面是否显示
      schedulingLoading: false,
      schedulingFormRules: {
        BusLinesId: [{ required: true, message: "请选择线路名称", trigger: "blur" }],
        SchedulingType: [{ required: true, message: "请选择排班依据", trigger: "blur" }],
        SchedulingDateRange: [{ required: true, message: "请输入本次排班时间", trigger: "blur" }],
        ShiftRotationDays: [{ required: true, message: "请输入班次轮换上多少天", trigger: "blur" }],
        ShiftRotationPositions: [{ required: true, message: "请输入班次轮换移多少个位置", trigger: "blur" }],
        RestRulesDays: [{ required: true, message: "请输入休息规则上多少天", trigger: "blur" }],
        RestRulesContinuityRestDays: [{ required: true, message: "请输入休息规则连休多少天", trigger: "blur" }]
      },
      //排班界面数据
      schedulingForm: {
        Id: 0,
        SchedulingTemplateId: 0,
        CreateBy: "",
        BusLinesId: 0,
        SchedulingDateRange: [{ required: true, message: "请输入时间", trigger: "blur" }],
        SchedulingType: "模板班次",
        SchedulingDateRange: null,
        ShiftRotationDays: 0,
        ShiftRotationPositions: 0,
        RestRulesDays: 0,
        RestRulesContinuityRestDays: 0,
        IsSkipClasses: "true",
        SchedulingTemplateList: [{
          Id: 0,
          SchedulingTemplateId: 0,
          monday: '',
          tuesday: '',
          wednesday: '',
          thursday: '',
          friday: '',
          saturday: '',
          sunday: '',
          SchedulingDateRange: [{ required: true, message: "请输入时间", trigger: "blur" }],
          mondaydisabled: false,
          tuesdaydisabled: false,
          wednesdaydisabled: false,
          thursdaydisabled: false,
          fridaydisabled: false,
          saturdaydisabled: false,
          sundaydisabled: false,
          mondaychecked: true,
          tuesdaychecked: true,
          wednesdaychecked: true,
          thursdaychecked: true,
          fridaychecked: true,
          saturdaychecked: true,
          sundaychecked: true
        }],
      },
      editFormVisible: false, //修改界面是否显示
      editLoading: false,
      editFormRules: {
        DriverId: [{ required: true, message: "请选择司机", trigger: "blur" }]
      },
      //修改界面数据
      editForm: {
        DriverOldId: 0,
        DriverId: 0,
        BusLinesId: 0,
        DepartureDateStr: "",
        SchedulingId: 0,
        DriverName: "",
        LineName: "",
        ShiftName: ""
      },
      editShiftNameFormVisible: false, //修改班次界面是否显示
      editShiftNameLoading: false,
      //修改班次界面数据
      editShiftNameForm: {
        SchedulingId: 0,
        AfterUpdateDriverName: "",
        DepartureDateStr: "",
        OldAfterUpdateBusLinesId: 0,
        AfterUpdateBusLinesId: 0,
        AfterUpdateDriverId: 0,
        AfterUpdateVehicleId: 0,
        ShiftName: "",
        OldShiftName: "",
        IsScheduling: true,
        IsCancelShift: false
      },
      multipleSelection: []
    };
  },
  methods: {
    //增加行
    handleAddExperienceline() {
      if (this.schedulingForm.SchedulingTemplateList == undefined) {
        this.schedulingForm.SchedulingTemplateList = new Array();
      }
      let obj = {
        Id: this.schedulingForm.SchedulingTemplateList.length,
        SchedulingTemplateId: null,
        monday: '',
        tuesday: '',
        wednesday: '',
        thursday: '',
        friday: '',
        saturday: '',
        sunday: '',
        SchedulingDateRange: [{ required: true, message: "请输入时间", trigger: "blur" }],
        mondaydisabled: false,
        tuesdaydisabled: false,
        wednesdaydisabled: false,
        thursdaydisabled: false,
        fridaydisabled: false,
        saturdaydisabled: false,
        sundaydisabled: false,
        mondaychecked: true,
        tuesdaychecked: true,
        wednesdaychecked: true,
        thursdaychecked: true,
        fridaychecked: true,
        saturdaychecked: true,
        sundaychecked: true
      };
      this.schedulingForm.SchedulingTemplateList.forEach(element => {
        if (element.monday != "") {
          obj.mondaydisabled = true;
          obj.mondaychecked = false;
        }
        if (element.tuesday != "") {
          obj.tuesdaydisabled = true;
          obj.tuesdaychecked = false;
        }
        if (element.wednesday != "") {
          obj.wednesdaydisabled = true;
          obj.wednesdaychecked = false;
        }
        if (element.thursday != "") {
          obj.thursdaydisabled = true;
          obj.thursdaychecked = false;
        }
        if (element.friday != "") {
          obj.fridaydisabled = true;
          obj.fridaychecked = false;
        }
        if (element.saturday != "") {
          obj.saturdaydisabled = true;
          obj.saturdaychecked = false;
        }
        if (element.sunday != "") {
          obj.sundaydisabled = true;
          obj.sundaychecked = false;
        }
      });
      this.schedulingForm.SchedulingTemplateList.push(obj);
    },
    //删除行
    handleDeleteExperience(index) {
      this.schedulingForm.SchedulingTemplateList.splice(index, 1)
    },

    //删除行
    checkboxchange(Id, week) {
      var disabled = event.target.checked;
      if (this.schedulingForm.SchedulingTemplateList[Id]) { }
      this.schedulingForm.SchedulingTemplateList.forEach(element => {
        if (Id != element.Id) {
          if (week == "monday") {
            element.mondaydisabled = disabled;
            element.mondaychecked = false;
          }
          if (week == "tuesday") {
            element.tuesdaydisabled = disabled;
          }
          if (week == "wednesday") {
            element.wednesdaydisabled = disabled;
          }
          if (week == "thursday") {
            element.thursdaydisabled = disabled;
          }
          if (week == "friday") {
            element.fridaydisabled = disabled;
          }
          if (week == "saturday") {
            element.saturdaydisabled = disabled;
          }
          if (week == "sunday") {
            element.sundaydisabled = disabled;
          }
        }

      });
    },


    selectCurrentRow(val) {
      this.currentRow = val;
    },
    callFunction(item) {
      this.filters = {
        busLinesId: item.busLinesId,
        departureDate: item.departureDate,
        schedulingTemplateId: item.schedulingTemplateId,
      };
      this[item.Func].apply(this, item);
    },
    operationButtonFunction(item, row) {
      this.currentRow = row;
      this[item.Func].apply(this, item);
    },
    handleSizeChange(val) {
      this.page = 1;
      this.pageSize = val;
      this.getScheduling();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getScheduling();
    },
    queryScheduling() {
      this.page = 1;
      this.getScheduling();
    },
    selectBusLinesIdChanged(val) {
      let _this = this;
      let schedulingType = _this.schedulingForm.SchedulingType;
      let schedulingTemplateId = _this.schedulingForm.SchedulingTemplateId;
      _this.schedulingFormObjectValueSet(_this, val, schedulingType, schedulingTemplateId);
      _this.getSchedulingTemplateList(val);
    },
    selectSchedulingTemplateIdChanged(val) {
      let _this = this;
      let busLinesId = _this.schedulingForm.BusLinesId;
      let schedulingType = _this.schedulingForm.SchedulingType;
      _this.schedulingFormObjectValueSet(_this, busLinesId, schedulingType, val);
    },
    schedulingTypeChange(val) {
      let _this = this;
      let busLinesId = _this.schedulingForm.BusLinesId;
      let schedulingTemplateId = _this.schedulingForm.SchedulingTemplateId;
      _this.$refs["schedulingForm"].validateField("BusLinesId");   // 此行单独校验schedulingForm表单下的线路名称单项
      _this.schedulingFormObjectValueSet(_this, busLinesId, val, schedulingTemplateId);
    },
    schedulingFormObjectValueSet(_this, busLinesId, val, schedulingTemplateId) {
      if (val === "模板班次") {
        _this.$set(_this.schedulingForm, "Id", 0);
        _this.$set(_this.schedulingForm, "ShiftRotationDays", "");
        _this.$set(_this.schedulingForm, "ShiftRotationPositions", "");
        _this.$set(_this.schedulingForm, "RestRulesDays", "");
        _this.$set(_this.schedulingForm, "RestRulesContinuityRestDays", "");
        _this.$set(_this.schedulingForm, "IsSkipClasses", "true");
      } else {
        let para = {
          busLinesId: busLinesId,
          schedulingTemplateId: schedulingTemplateId === "" ? 0 : schedulingTemplateId
        };
        getSchedulingRuleData(para).then(res => {
          let schedulingRuleData = res.data;
          _this.$set(_this.schedulingForm, "Id", schedulingRuleData.Id);
          _this.$set(_this.schedulingForm, "ShiftRotationDays", schedulingRuleData.Id === 0 ? "" : schedulingRuleData.ShiftRotationDays);
          _this.$set(_this.schedulingForm, "ShiftRotationPositions", schedulingRuleData.Id === 0 ? "" : schedulingRuleData.ShiftRotationPositions);
          _this.$set(_this.schedulingForm, "RestRulesDays", schedulingRuleData.Id === 0 ? "" : schedulingRuleData.RestRulesDays);
          _this.$set(_this.schedulingForm, "RestRulesContinuityRestDays", schedulingRuleData.Id === 0 ? "" : schedulingRuleData.RestRulesContinuityRestDays);
          _this.$set(_this.schedulingForm, "IsSkipClasses", schedulingRuleData.IsSkipClasse === 0 ? "false" : "true");
        });
      }
    },
    //自定义的排序逻辑
    sortByPositionSerial(obj1, obj2, index) {
      let positionSerial1 = obj1.ShiftNameItems[index].PositionSerial;
      let positionSerial2 = obj2.ShiftNameItems[index].PositionSerial;
      return positionSerial1 - positionSerial2;
    },
    //预览
    handlePreview() {
      let _this = this;
      _this.$refs.schedulingForm.validate(valid => {
        if (valid) {
          let para = Object.assign({}, _this.schedulingForm);
          para.SchedulingDateRange = para.SchedulingDateRange.toString();
          para.SchedulingTemplateList.forEach(element => {
            element.SchedulingDateRange = "";
          });
          para.SchedulingTemplateId = 0;

          previewScheduling(para).then(res => {
            if (res.success !== undefined && res.success === false) {
              _this.$message({
                message: res.msg,
                type: "error"
              });
            } else {
              _this.List = new Array();
              res.data.forEach(element => {
                if (element.data.length > 0) {
                  let previewSchedulingList = element.data;
                  let previewDynamicTableHead = [];
                  let shiftNameItems = previewSchedulingList[0].ShiftNameItems;
                  shiftNameItems.forEach((item, index) => {
                    previewDynamicTableHead.push({ index: index, property: 'ShiftNameItems', label: item.DateStr });
                  });
                  _this.List.push({ previewSchedulingList: previewSchedulingList, previewDynamicTableHead: previewDynamicTableHead });
                  _this.previewVisible = true;
                }

              });
              // _this.previewSchedulingList = res.data.data;
              // if(_this.previewSchedulingList.length > 0){
              //   _this.previewDynamicTableHead = [];
              //   let shiftNameItems = _this.previewSchedulingList[0].ShiftNameItems;
              //   shiftNameItems.forEach((item, index) => {
              //     _this.previewDynamicTableHead.push({ index: index, property: 'ShiftNameItems' ,label: item.DateStr});
              //   });
              //   _this.previewVisible = true;
              // }else{
              //   _this.$message({
              //     message: '无预览数据',
              //     type: "info"
              //   });
              // }
            }
          });
        }
      });
    },
    //获取排班列表
    getScheduling() {
      let _this = this;
      let para = {
        busLinesId: _this.filters.busLinesId,
        departureDate: (_this.filters.departureDate === "" || _this.filters.departureDate === null) ? this.defaultDate() : _this.filters.departureDate,
        schedulingTemplateId: _this.filters.schedulingTemplateId === "" ? 0 : _this.filters.schedulingTemplateId,
        page: _this.page,
        pageSize: _this.pageSize
      };
      _this.listLoading = true;
      getSchedulingListPage(para).then(res => {
        _this.total = res.data.dataCount;
        _this.schedulingList = res.data.data;
        _this.listLoading = false;
        if (_this.schedulingList.length > 0) {
          _this.dynamicTableHead = [];

          let shiftNameItems = _this.schedulingList[0].ShiftNameItems;
          shiftNameItems.forEach((item, index) => {
            _this.dynamicTableHead.push({ index: index, property: 'ShiftNameItems', label: item.DateStr });
          });
        }
        _this.getBusLinesIdDriverIdListData();
      });
    },
    getBusLines(pageSizePara) {
      getBusLinesListPage(pageSizePara).then(res => {
        this.busLiness = res.data.response.data;
        this.filters.busLinesId = this.busLiness.length > 0 ? this.busLiness[0].Id : "";
        this.getScheduling();
      });
    },
    getDriverList() {
      let driverPara = {
        companyId: "",
        driverName: "",
        employmentStatus: "",
        page: 1,
        pageSize: 200
      };
      getDriverListPage(driverPara).then(res => {
        this.driverList = res.data.response.data;
      });
    },
    getVehiclesList() {
      let vehiclesPara = {
        companyId: '',
        busLinesId: '',
        licensePlateNumber: '',
        terminalsId: '',
        simId: '',
        page: 1,
        pageSize: 200
      };
      getVehiclesListPage(vehiclesPara).then(res => {
        this.vehicleList = res.data.response.data;
      });
    },
    getShiftNameList(schedulingTemplateId) {
      this.shiftNameList = undefined;
      let para = {
        schedulingTemplateId: schedulingTemplateId
      };
      getShiftNameListPage(para).then(res => {
        this.shiftNameList = res.data;
        this.shiftNameList.push("休息");
      });
    },
    getBusLinesIdDriverIdListData() {
      let para = {
        busLinesId: this.filters.busLinesId,
        departureDate: (this.filters.departureDate === "" || this.filters.departureDate === null) ? this.defaultDate() : this.filters.departureDate,
        schedulingTemplateId: this.filters.schedulingTemplateId === "" ? 0 : this.filters.schedulingTemplateId
      };
      getBusLinesIdDriverIdList(para).then(res => {
        this.busLinesIdDriverList = res.data;
      });
    },
    //初始化驾驶员下拉列表
    initDriverSelectList(driverId) {
      this.driverSelectList = [];
      this.driverList.forEach((item, index) => {
        var driverItem = {};
        driverItem.disabled = false;
        driverItem.id = item.Id;
        driverItem.name = item.Name;

        if (this.busLinesIdDriverList.includes(item.Id) && item.Id !== driverId) {
          driverItem.disabled = true;
        }

        this.driverSelectList.push(driverItem);
      });
    },
    // 获取导出文件名称，若是1号则当月数据，否则30天的数据
    getFileName() {
      let _this = this;
      let busLiness = _this.busLiness.filter(it => it.Id === _this.filters.busLinesId);
      let fileName = busLiness.length > 0 ? busLiness[0].LineChineseName : '';
      if (_this.filters.departureDate !== null && _this.filters.departureDate !== null) {
        let date = new Date(_this.filters.departureDate);
        let d = date.getDate();
        if (d === 1) {
          let m = date.getMonth() + 1;
          fileName += m + '月份';
        } else {
          let startDateStr = util.formatDate.format(date, "yyyy-MM-dd");
          let startDate = new Date(startDateStr);
          let endDate = startDate.setTime(startDate.getTime() + 29 * 24 * 60 * 60 * 1000);
          let endDateStr = util.formatDate.format(new Date(endDate), "yyyy-MM-dd");
          fileName += startDateStr + '至' + endDateStr;
        }
      }

      return fileName + '排班数据';
    },
    //设置默认日期
    defaultDate() {
      let date = new Date();
      let year = date.getFullYear().toString();
      let month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1).toString() : (date.getMonth() + 1).toString();
      let day = date.getDate() < 10 ? '0' + date.getDate().toString() : date.getDate().toString();
      let departureDate = year + '-' + month + '-' + day;
      this.$refs.child.setDepartureDate(departureDate);
      return departureDate;
    },
    //查看操作日记
    lookUpOperateDataLog() {
      this.operateDataLogFormVisible = true;
      this.entityKey = this.editShiftNameForm.SchedulingId;
    },
    getSchedulingTemplateList(busLinesId, schedulingTemplateId) {
      this.schedulingTemplateList = [];
      this.$set(this.schedulingForm, "SchedulingTemplateId", "");
      let para = {
        busLinesId: busLinesId,
        pageSize: 20
      };
      getSchedulingTemplateListPage(para).then(res => {
        this.schedulingTemplateList = res.data.response.data;
        this.$set(this.schedulingForm, "SchedulingTemplateId", schedulingTemplateId);
      });
    },
    // 排班
    schedulingSubmit: function () {
      let _this = this;
      this.$refs.schedulingForm.validate(valid => {
        if (valid) {
          this.$confirm("确认生成排班吗？", "提示", {}).then(() => {
            this.schedulingLoading = true;
            // let para = Object.assign({}, this.schedulingForm);
            // para.SchedulingDateRange = para.SchedulingDateRange.toString();
            // para.SchedulingTemplateId = para.SchedulingTemplateId === "" ? 0 : para.SchedulingTemplateId;

            let para = Object.assign({}, _this.schedulingForm);
            para.SchedulingDateRange = para.SchedulingDateRange.toString();
            para.SchedulingTemplateList.forEach(element => {
              element.SchedulingDateRange = "";
            });
            para.SchedulingTemplateId = 0;

            var user = JSON.parse(window.localStorage.user);

            if (user && user.uID > 0) {
              para.CreateId = user.uID;
              para.CreateBy = user.uRealName;
            } else {
              this.$message({
                message: "用户信息为空，先登录",
                type: "error"
              });
              _this.$router.replace(
                _this.$route.query.redirect ? _this.$route.query.redirect : "/"
              );
            }

            addScheduling(para).then(res => {
              if (util.isEmt.format(res)) {
                this.schedulingLoading = false;
                return;
              }
              if (res.data.success) {
                this.schedulingLoading = false;
                this.$message({
                  message: res.data.msg,
                  type: "success"
                });
                this.$refs["schedulingForm"].resetFields();
                this.schedulingFormVisible = false;
                this.filters.busLinesId = para.BusLinesId;
                this.filters.departureDate = para.SchedulingDateRange.split(",")[0];
                this.$refs.child.setBusLinesId(this.filters.busLinesId);
                this.$refs.child.setDepartureDate(util.formatDate.format(new Date(this.filters.departureDate), "yyyy-MM-dd"));
                this.getScheduling();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error"
                });
              }
            });
          });
        }
      });
    },
    // 编辑
    editSubmit: function () {
      let _this = this;
      _this.$refs.editForm.validate(valid => {
        if (valid) {
          _this.$confirm("确认修改吗？", "提示", {}).then(() => {
            _this.editLoading = true;
            let para = Object.assign({}, _this.editForm);
            para.BusLinesId = _this.filters.busLinesId;
            para.DepartureDateStr = (_this.filters.departureDate === "" || _this.filters.departureDate === null) ? this.defaultDate() : _this.filters.departureDate;

            editScheduling(para).then(res => {
              if (util.isEmt.format(res)) {
                _this.editLoading = false;
                return;
              }
              if (res.data.success) {
                _this.editLoading = false;
                _this.$message({
                  message: res.data.msg,
                  type: "success"
                });
                _this.$refs["editForm"].resetFields();
                _this.editFormVisible = false;
                _this.getScheduling();
              } else {
                _this.$message({
                  message: res.data.msg,
                  type: "error"
                });
              }
            });
          });
        }
      });
    },
    // 修改班次
    editShiftNameSubmit: function () {
      let _this = this;
      _this.$refs.editShiftNameForm.validate(valid => {
        if (valid) {
          _this.$confirm("确认修改班次吗？", "提示", {}).then(() => {
            // 排班线路变换
            if (_this.editShiftNameForm.OldAfterUpdateBusLinesId !== _this.editShiftNameForm.AfterUpdateBusLinesId) {
              _this.$confirm("是否取消？", "提示", {
                distinguishCancelAndClose: true, //区别右上角的X（action：close）和否按钮（action：cancel）
                confirmButtonText: '是',
                cancelButtonText: '否', //相当于 取消按钮
              }).then(() => {
                _this.editShiftNameForm.IsCancelShift = true;
                _this.saveEditSchedulingBusLinesIdAndShiftName(_this);
              }).catch(action => {
                if (action === 'cancel') {
                  _this.editShiftNameForm.IsScheduling = false;
                  _this.editShiftNameForm.IsCancelShift = false;
                  _this.saveEditSchedulingBusLinesIdAndShiftName(_this);
                }
              });
            } else {
              _this.saveEditSchedulingBusLinesIdAndShiftName(_this);
            }
          }).catch(() => {

          });
        }
      });
    },
    saveEditSchedulingBusLinesIdAndShiftName(_this) {
      _this.editShiftNameLoading = true;
      let para = Object.assign({}, _this.editShiftNameForm);
      editSchedulingBusLinesIdAndShiftName(para).then(res => {
        if (util.isEmt.format(res)) {
          _this.editShiftNameLoading = false;
          return;
        }
        if (res.data.success) {
          _this.editShiftNameLoading = false;
          _this.$message({
            message: res.data.msg,
            type: "success"
          });
          _this.$refs["editShiftNameForm"].resetFields();
          _this.editShiftNameFormVisible = false;
          _this.getScheduling();
        } else {
          _this.$message({
            message: res.data.msg,
            type: "error"
          });
        }
      });
    },
    selsChange: function (sels) {
      this.sels = sels;
    },
    //批量删除
    batchRemove: function () {
      this.$message({
        message: "该功能未开放",
        type: "warning"
      });
    },
    //显示排班界面
    handleAdd() {
      this.schedulingFormVisible = true;
      this.schedulingForm = {
        CreateBy: "",
        BusLinesId: this.filters.busLinesId,
        SchedulingTemplateId: this.filters.schedulingTemplateId,
        SchedulingType: "模板班次",
        IsSkipClasses: "true"
      };
      this.schedulingForm.SchedulingTemplateList = [{
        Id: 0,
        SchedulingTemplateId: null,
        monday: "",
        tuesday: "",
        wednesday: "",
        thursday: "",
        friday: "",
        saturday: "",
        sunday: "",
        SchedulingDateRange: [{ required: true, message: "请输入时间", trigger: "blur" }],
        mondaydisabled: false,
        tuesdaydisabled: false,
        wednesdaydisabled: false,
        thursdaydisabled: false,
        fridaydisabled: false,
        saturdaydisabled: false,
        sundaydisabled: false,
        mondaychecked: true,
        tuesdaychecked: true,
        wednesdaychecked: true,
        thursdaychecked: true,
        fridaychecked: true,
        saturdaychecked: true,
        sundaychecked: true
      }];
      this.getSchedulingTemplateList(this.filters.busLinesId, this.filters.schedulingTemplateId);
    },
    //显示编辑界面
    handleEdit() {
      this.editFormVisible = true;
      this.editForm.DriverId = this.currentRow.DriverId;
      this.editForm.DriverOldId = this.currentRow.DriverId;
      this.initDriverSelectList(this.currentRow.DriverId);
    },
    //显示班次编辑界面
    handleShiftNameEdit(driverName, shiftNameItem) {
      if (shiftNameItem.SchedulingId === 0) {
        this.$message({
          message: '司机：' + driverName + ' | ' + shiftNameItem.DateStr + '无数据，不可编辑',
          type: "error"
        });
      } else {
        this.editShiftNameFormVisible = true;
        this.editShiftNameForm.SchedulingId = shiftNameItem.SchedulingId;
        this.editShiftNameForm.AfterUpdateDriverName = driverName;
        this.editShiftNameForm.OldAfterUpdateBusLinesId = shiftNameItem.AfterUpdateBusLinesId;
        this.editShiftNameForm.AfterUpdateBusLinesId = shiftNameItem.AfterUpdateBusLinesId;
        this.editShiftNameForm.AfterUpdateDriverId = shiftNameItem.AfterUpdateDriverId;
        this.editShiftNameForm.AfterUpdateVehicleId = (shiftNameItem.AfterUpdateVehicleId === "" || shiftNameItem.AfterUpdateVehicleId === null) ? shiftNameItem.VehicleId : shiftNameItem.AfterUpdateVehicleId;
        this.editShiftNameForm.DepartureDateStr = shiftNameItem.DepartureDateStr;
        this.editShiftNameForm.ShiftName = shiftNameItem.ShiftName;
        this.editShiftNameForm.OldShiftName = shiftNameItem.ShiftName;
        this.editShiftNameForm.IsCancelShift = shiftNameItem.IsCancelShift;
        this.getShiftNameList(shiftNameItem.SchedulingTemplateId);
      }
    },
    //清空排班
    handleClearScheduling() {
      let _this = this;
      _this.$confirm("确认清空排班吗？", "提示", {}).then(() => {
        let para = {
          busLinesId: _this.filters.busLinesId,
          departureDate: _this.filters.departureDate
        };
        clearScheduling(para).then(res => {
          if (res.data.success) {
            _this.$message({
              message: res.data.msg,
              type: "success"
            });
            _this.getScheduling();
          } else {
            _this.$message({
              message: res.data.msg,
              type: "error"
            });
          }
        });
      });
    },
    //删除排班
    handleDeleteScheduling() {

      if (!(this.multipleSelection.length > 0)) {
        this.$message.error("请选择要操作的数据行");
        return;
      }
      this.$confirm("确认批量删除吗？", "提示").then(() => {
        //批量删除
        var driverIdS = this.multipleSelection.map(t => t.DriverId).join(",");
        var vehicleIdS = this.multipleSelection.map(t => t.VehicleId).join(",");
        // let para = { 
        //   // driverIdS: driverIdS,
        //   // vehicleIdS: vehicleIdS,
        //   busLinesId: this.filters.busLinesId,
        //   departureDate: this.filters.departureDate
        // };
        let para = this.multipleSelection;
        deleteScheduling(para)
          .then(res => {
            if (res.data.success) {
              this.getScheduling();
              this.$message.success("批量删除成功!");
            } else {
              this.$message.error(res.data.msg);
            }
          });
      });
    },

    //修改司机change
    Drivechange() {
      let _this = this;
      let para = {
        busLinesId: _this.editShiftNameForm.AfterUpdateBusLinesId,
        driverId: _this.editShiftNameForm.AfterUpdateDriverId,
        vehicleId: '',
        isBind: '',
        page: _this.page,
        pageSize: _this.pageSize
      };
      getByDriverIdVehiclesData(para).then(res => {
        if (res.data.data !== null) {
          if (res.data.data.length > 0) {
            _this.editShiftNameForm.AfterUpdateVehicleId = res.data.data[0].Id;
          }
        }
      });
    },
    //导入排班
    handleImportScheduling() {

    },
    //导出排班
    handleExportScheduling() {
      let _this = this;
      let para = {
        busLinesId: _this.filters.busLinesId,
        departureDate: (_this.filters.departureDate === "" || _this.filters.departureDate === null) ? this.defaultDate() : _this.filters.departureDate,
        schedulingTemplateId: _this.filters.schedulingTemplateId === "" ? 0 : _this.filters.schedulingTemplateId,
        page: _this.page,
        pageSize: _this.pageSize
      };
      exportScheduling(para).then(res => {
        let blob = new Blob([res.data], {
          type: "application/vnd.ms-excel",
        }); // 2.获取请求返回的response对象中的blob 设置文件类型，这里以excel为例
        let url = window.URL.createObjectURL(blob); // 3.创建一个临时的url指向blob对象
        // 4.创建url之后可以模拟对此文件对象的一系列操作，例如：预览、下载
        let a = document.createElement("a");
        a.href = url;
        let fileName = _this.getFileName();
        a.download = fileName + ".xlsx";
        a.click();
        // 5.释放这个临时的对象url
        window.URL.revokeObjectURL(url);
      },
        (err) => {
          resolve(err.response);
        })
        .catch((error) => {
          reject(error);
        });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    }
  },
  mounted() {
    let pageSizePara = {
      pageSize: 100
    };
    this.getBusLines(pageSizePara);
    this.getDriverList();
    this.getVehiclesList();


    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    //第一种写法，每个页面都需要写方法，但是可以做特性化处理
    // this.getButtonList(routers);

    //第二种写法，封装到 permissionRouter.js 中
    this.buttonList = getButtonList(this.$route.path, routers);
    this.operationButtonList = getOperationButtonList(this.$route.path, routers);
  }
}
</script>

<style scoped></style>
